<template>
  <div>
    <div style="z-index: 99" class="mt-3 mt-sm-0 mb-3 mx-2 mb-sm-3">
      <label class=""><strong> Filter by Year & Month </strong></label>
      <br />
      <a-date-picker
        mode="month"
        v-model="value"
        @change="onDateValueChange"
        @panelChange="handlePanelChange2"
        @openChange="handleOpenChange"
        format="YYYY-MM"
        placeholder="Filter by year & month"
        ref="datePicker"
        :open="openDatePicker"
      >
        <template slot="renderExtraFooter">
          <a-button class="float-right my-2" @click="handleFilterMonth"
            >Filter</a-button
          >
        </template>
      </a-date-picker>
      <a-button class="ml-1" @click="handleResetDate" :disabled="!value"
        >See All</a-button
      >
      <br />
    </div>
    <div class="mb-4">
      <a-table
        :columns="columns"
        :dataSource="filteredItems"
        :pagination="true"
        :class="$style.table"
        rowKey="id"
        :loading="isLoading"
      >
        <template slot="title_video" slot-scope="title_video, record">
          <router-link
            :to="{ path: '/video/details/' + record.id }"
            class="kit__utils__link font-size-16"
            >{{ record.title }}</router-link
          >
        </template>
        <template slot="createdAt" slot-scope="createdAt">
          <div>
            <div>
              {{ createdAt ? moment(createdAt).format('DD MMM YYYY') : '-' }}
            </div>
          </div>
        </template>
        <template slot="tag" slot-scope="tag">
          <div>
            <div>{{ tag !== 'null' ? tag : 'Artikel Umum' }}</div>
          </div>
        </template>
        <template slot="thumbnail" slot-scope="thumbnail">
          <img
            v-if="thumbnail"
            :src="`${BASE_URL}${thumbnail}`"
            alt="Thumbnail Video Vertical"
            :class="$style['custom-image-video']"
            @click="() => handleOpenModal(thumbnail)"
          />
          <a-empty v-else></a-empty>
        </template>
        <template slot="tag" slot-scope="tag">
          <div>
            <div>{{ tag !== 'null' ? tag : 'Artikel Umum' }}</div>
          </div>
        </template>
        <template slot="description" slot-scope="description">
          <div>{{ description ? description : '-' }}</div>
        </template>
      </a-table>
    </div>
    <a-modal
      :title="selectedThumbnail"
      :visible="openedModal"
      @ok="handleCloseModal"
      @cancel="handleCloseModal"
    >
      <img
        :src="`${BASE_URL}${selectedThumbnail}`"
        alt="Thumbnail Video Vertical"
        :class="$style['custom-modal-image-video']"
      />
    </a-modal>
  </div>
</template>
<script>
// import { getAll, getTotalViews } from '@/services/axios/api/artikel'
import moment from 'moment'
import apiClient from '../../../services/axios'
import { BASE_URL } from '../../../config'
const columns = [
  {
    title: 'Judul Video Vertical',
    dataIndex: 'title',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'title_video' },
    sorter: (a, b) => {
      return a.title.localeCompare(b.title)
    },
  },
  {
    title: 'Deskripsi',
    dataIndex: 'description',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Tanggal Dibuat',
    dataIndex: 'createdAt',
    className: 'bg-transparent text-gray-6 width-50',
    scopedSlots: { customRender: 'createdAt' },
    sorter: (a, b) => {
      return a.createdAt.localeCompare(b.createdAt)
    },
  },

  {
    title: 'Dilihat Sebanyak',
    dataIndex: 'totalViews',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'totalViews' },
    sorter: (a, b) => {
      return a.totalViews - b.totalViews > b.totalViews - a.totalViews
        ? -1
        : a.totalViews - b.totalViews < b.totalViews - a.totalViews
        ? 1
        : 0
    },
  },
  {
    title: 'Thumbnail',
    dataIndex: 'thumbnail',
    className: 'bg-transparent text-gray-6 width-50',
    scopedSlots: { customRender: 'thumbnail' },
  },
]

export default {
  name: 'TabelVideo',
  data: function () {
    return {
      columns,
      BASE_URL,
      items: [],
      filteredItems: [],
      months: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
      ],
      isLoading: false,
      isAdmin: false,
      selectedMonthFilter: undefined,
      date: null,
      value: null,
      openDatePicker: false,
      selectedThumbnail: null,
      openedModal: false,
    }
  },
  created() {
    this.getVideoVertical()
    this.getRole()
  },
  methods: {
    moment,
    async getVideoVertical() {
      this.isLoading = true
      const res = await apiClient.get('/videoVertical')
      // const monthsFilter = []
      console.log(res.data, '<<<')

      this.items = res.data
      this.filteredItems = res.data
      this.$store.state.videoData = res.data
      this.isLoading = false
      // console.log(res, '<<<<<<<')
    },
    getRole() {
      const role = window.localStorage.getItem('role')
      console.log(role)
      if (role === 'admin' || role === 'astrazeneca') {
        this.isAdmin = true
      }
    },
    handleRangePicker(e) {
      console.log(e)
    },
    onDateValueChange(val) {
      this.date = val
      this.value = val
      this.getVideoVertical()
    },
    handleResetDate() {
      this.date = null
      this.value = null
      this.getVideoVertical()
    },
    handlePanelChange2(value) {
      this.date = value
      this.value = moment(value._d)
    },
    handleFilterMonth() {
      this.openDatePicker = false
      this.getVideoVertical()
    },
    handleOpenChange(status) {
      this.openDatePicker = status
      this.value = moment()
    },
    handleOpenModal(thumbnail) {
      this.openedModal = true
      this.selectedThumbnail = thumbnail
    },
    handleCloseModal() {
      this.openedModal = false
      this.selectedThumbnail = null
    },
    // onFilter(items) {
    //   console.log(this.selectedMonthFilter, '<<<<< BEFORE')

    //   this.getVideoVertical(this.selectedMonthFilter)
    //   // this.filteredItems = items.filter((item) => {
    //   //   for (var key in filters) {
    //   //     if (
    //   //       !filters[key].includes(this.months[moment(item.createdAt).month()])
    //   //     ) {
    //   //       return false
    //   //     }
    //   //   }
    //   //   return true
    //   // })
    //   // console.log(this.filteredItems, '<<<<<< AFTER')
    // },
  },
}
</script>
<style lang="scss" module>
@import './style.module.scss';
.custom-image-video {
  width: 150px;
  height: 100px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    scale: 1.2;
  }
}
.custom-modal-image-video {
  width: 100%;
  height: 100%;
}
</style>
